import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { userRegister, clearAuthErrors } from 'store/modules/auth/actions'
import RegisterComponent from 'bundles/LoginRegister/components/RegisterComponent'

class RegisterContainer extends PureComponent {

    render() {
        return (
            <RegisterComponent
                {...this.props}
            />
        )
    }

}

const mapStateToProps = (state) => {
    return {
        error: state.auth.error,
        isFetching: state.auth.isFetching,
        registerSuccess: state.auth.registerSuccess,
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        userRegister: (obj) => {
            dispatch(userRegister(obj))
        },
        clearAuthErrors: () => {
            dispatch(clearAuthErrors())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterContainer)